/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum InventoryCountStatus {
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Canceled = 'CANCELED'
}
